import { BaseDto } from '../base.dto';

export class BillingChannelTypeDto extends BaseDto {
  name: string;
}